const StudentInstituteEnrollment = {
    "enrollment": "Student Institute Enrollment",
    "student": "Student",
    "institute": "Institute",
    "branch": "Select Office",
    "status": "Status",
    "search": "Search",
    "error_student": "Select Student",
    "error_institute": "Select Institute",
    "error_branch": "Select Branch Office",
    "error_status": "Select Status",
    "table_student": "STUDENT",
    "table_institute": "INSTITUTE",
    "table_branch": "BRANCH OFFICE",
    "table_status": "STATUS",
}

export default StudentInstituteEnrollment;
